import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';
import { useAuthContext } from '../../modules/login/AuthContext';

type PrivateRouteProps = RouteProps & {
  loginPath?: string;
};

const PrivateRoute = ({
  component: Component,
  render,
  loginPath = '/login',
  ...props
}: PrivateRouteProps) => {
  const { loggedin, redirectPath, loading } = useAuthContext();
  const path = redirectPath !== '/' ? `${loginPath}?redirectPath=${redirectPath}` : loginPath;

  const loggedInRender = (renderProps: RouteComponentProps) => {
    if (Component) {
      return <Component {...renderProps} />;
    }

    if (render) {
      return render(renderProps);
    }
  };

  if (loading) {
    return null;
  }

  return (
    <Route
      exact
      {...props}
      render={(renderProps) => (loggedin ? loggedInRender(renderProps) : <Redirect to={path} />)}
    />
  );
};

export default PrivateRoute;
